import { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { addScreenAction, updateScreenAction, resetAction } from "../actions";
import Icon from "../components/Icon";

function UsageBanner({ screens, reset, showSteps }) {
  const bannerRef = useRef();

  useEffect(() => {
    const updateSticky = () => {
      const headerHeight = getComputedStyle(document.documentElement)
        .getPropertyValue('--trs-header-height')
        .trim();
      
      if (bannerRef.current && headerHeight) {
        const width = window.innerWidth;
        const height = window.innerHeight;

        const isSpecificDevice = 
          (width === 1024 && height === 1366) ||
          (width === 853 && height === 1280) ||
          (width === 912 && height === 1368);
        
        if (isSpecificDevice) {
          bannerRef.current.setAttribute('uk-sticky', `media: 960`);
        } else {
          bannerRef.current.setAttribute('uk-sticky', `media: 960; offset: ${headerHeight}`);
        }
      }
    };

    updateSticky();
    window.addEventListener('resize', updateSticky);

    return () => {
      window.removeEventListener('resize', updateSticky);
    };
  }, []);
  
  return (
    <div ref={bannerRef} id="UsageBanner" className=""> 
      <div className="uk-container uk-container-expand uk-padding-small">
        <div className="uk-grid uk-grid-small uk-width-3-4@l uk-margin-auto uk-child-width-1-2 uk-child-width-1-3@m uk-flex uk-flex-between uk-flex-middle">
          <div className="uk-visible@m uk-width-1-3@m">
            <h2>Pump Selector Tool</h2>
          </div>
          <div className="usage uk-flex-last@m uk-flex uk-flex-middle uk-flex-left@m uk-width-4-5 uk-width-1-3@m">
            <span
              className="start-over uk-link uk-margin-left uk-display-inline-block uk-visible@m uk-margin-auto-left"
              uk-tooltip="title: Start Over"
              onClick={() => reset()}
            >
              <Icon iconName="start-over" />
            </span>
          </div>
          {!showSteps && (
            <div className="uk-text-right uk-text-center@m uk-width-1-5 uk-width-1-3@m">
              <p className="step-status uk-margin-remove">
                <span>{screens.step}</span> | 6
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  screens: state.questions,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      updateScreen: updateScreenAction,
      addScreen: addScreenAction,
      reset: resetAction,
    },
    dispatch
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(UsageBanner);